if (!customElements.get('treatment-directory')) {
  class TreatmentDirectory extends HTMLElement {
    connectedCallback() {
      this.handleToggle = this.onToggle.bind(this);
      this.addEventListener('toggle', this.handleToggle, true);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.handleToggle, true);
    }

    onToggle(event) {
      const category = event.target;

      if (!(category instanceof HTMLDetailsElement) || !category.open || !this.contains(category)) {
        return;
      }

      requestAnimationFrame(() => {
        this.ensureCategoryInView(category);
      });
    }

    ensureCategoryInView(category) {
      const target = category.querySelector('[data-treatment-directory-summary]') || category;
      const rect = target.getBoundingClientRect();
      const stickyOffset = this.getStickyOffset();
      const isAboveViewport = rect.top < stickyOffset;
      const isBelowViewport = rect.top > window.innerHeight;

      if (!isAboveViewport && !isBelowViewport) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      target.scrollIntoView({
        block: 'start',
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    getStickyOffset() {
      const stickyAreaHeight = getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height');
      const parsed = Number.parseFloat(stickyAreaHeight);

      return Number.isFinite(parsed) ? parsed : 0;
    }
  }

  customElements.define('treatment-directory', TreatmentDirectory);
}
